module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-input-number",
    class: [
      _vm.size ? 'zk-input-number--' + _vm.size : '',
      {
        'is-disabled': _vm.disabled
      }
    ]
  }, [_c('zk-input', {
    class: {
      'is-active': _vm.inputActive
    },
    attrs: {
      "value": _vm.currentValue,
      "disabled": _vm.disabled,
      "size": _vm.size
    },
    on: {
      "blur": _vm.handleBlur,
      "input": _vm.handleInput
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.increase($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.decrease($event)
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.decrease),
      expression: "decrease"
    }],
    staticClass: "zk-input-number__decrease zk-icon-minus",
    class: {
      'is-disabled': _vm.minDisabled
    },
    on: {
      "mouseenter": function($event) {
        _vm.activeInput(_vm.minDisabled)
      },
      "mouseleave": function($event) {
        _vm.inactiveInput(_vm.minDisabled)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.increase),
      expression: "increase"
    }],
    staticClass: "zk-input-number__increase zk-icon-plus",
    class: {
      'is-disabled': _vm.maxDisabled
    },
    on: {
      "mouseenter": function($event) {
        _vm.activeInput(_vm.maxDisabled)
      },
      "mouseleave": function($event) {
        _vm.inactiveInput(_vm.maxDisabled)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-4bccde82"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/input-number/src/input-number.vue
// module id = 255
// module chunks = 0